import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithProtectedAdminRouteHealthProvider, useProtectedAdminRouteHealth] = createComponentHealth('ProtectedAdminRoute');
